import React from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useWindowSize } from "../../hooks";
import {
  filterAllProductsByITF,
} from "../../utils";

import { useTranslation } from 'react-i18next';

const ShowBreadCrumb = ({ breadCrumbObject, currentLocation }) => {

  return breadCrumbObject.map((element, i) => {
    return (
      <div key={i} className="breadCrumb-element">
        {currentLocation.pathname === element.path ? (
          <div className="breadCrumb-name active">{element.name}</div>
        ) : (
          <>
            <div className="split-line" />
            {i === 0 ? (
              <Link
                to={
                  element.query !== ""
                    ? `/search?key=${element.query}`
                    : element.path
                }
              >
                <div className="breadCrumb-type">{element.type}</div>
              </Link>
            ) : (
              <Link to={element.path}>
                <div className="breadCrumb-name">{element.name}</div>
              </Link>
            )}
          </>
        )}
      </div>
    );
  });
};

const MobileBreadCrumb = ({ breadCrumbObject, currentLocation }) => {

  const navigate = useNavigate();
  const path = currentLocation.pathname.split("/").filter(element => element);
  path.splice(-1);
  const lastElementOfBread = breadCrumbObject.slice(-1).pop();

  return (
    <div key={lastElementOfBread.name} onClick={() => window.location.href = "#/" + path.join("/")} className="breadCrumb-mobile-element">
      <div className="icon" />
      <div className="breadCrumb-name active">{lastElementOfBread.name}</div>
    </div>
  );
};

const getBreadCrumbName = (element, products,categorias) => {

  // const getProductsByEAN = products && removeDuplicateEANProducts(products);


  const filterByCategories =
    categorias && categorias.filter((el) => el.code === element);

  const filterProductsByEAN =
  products && products.filter((ele) => ele.ean === element);

  if (filterByCategories && filterByCategories.length > 0) {

    const getTitle = filterByCategories[0];

    return getTitle && getTitle.name;
  }

  if (filterProductsByEAN && filterProductsByEAN.length > 0) {

    const getTitle = filterProductsByEAN[0];

    return getTitle && getTitle.titulo;
  } else {
    const filterProductsByITF =
      products && filterAllProductsByITF(products, element);

    const getCode = filterProductsByITF && filterProductsByITF[0];

    return getCode && getCode.code;
  }
};

const BreadCrumb = ({selectedProduct}) => {
  const { t } = useTranslation(['data'])

  let route = "";
  const currentLocation = useLocation();
  const size = useWindowSize();

  const splitRoute = currentLocation.pathname.split("/").filter((i) => i);

  const products = selectedProduct

  const { search } = useSelector((state) => state.catalog);

  const breadCrumbObject = splitRoute.map((el) => {

    let name = "";
    let type = "";

    if (el === "marcas") type = "Por marcas";
    if (el === "catalogos") type = "Por catálogos";
    if (el === "categorias") type = "Por categorías";
    if (el === "search") type = "Buscador";
    else if (
      el !== "categorias" &&
      el !== "catalogos" &&
      el !== "marcas" &&
      el !== "search"
    ) {
      const findName = getBreadCrumbName(decodeURIComponent(el), products);

      findName && findName.length !== 0 ? (name = findName) : (name = decodeURIComponent(el));
    }

    route += "/" + el;

    let breadObj = {
      type: type,
      name: type === "Buscador" ? t('buscador') : name.toLowerCase(),
      path: route,
      query: el === "search" && search ? search : "",
    };

    return breadObj;
  });

  return (
    <div className="breadCrumb-container">

      { size.width <= 428 && <MobileBreadCrumb
          breadCrumbObject={breadCrumbObject}
          currentLocation={currentLocation}
        />}

        {size.width > 428 &&
        <ShowBreadCrumb
          breadCrumbObject={breadCrumbObject}
          currentLocation={currentLocation}
        />
          }
    </div>
  );
};

export default BreadCrumb;
